import { LocationMarker } from '../interfaces';

const groundwaterDesc = `To protect lakes and wetlands, we are transferring our groundwater abstraction to less sensitive locations, including deeper aquifers.`;
const damLink = '/where/dams';
const desalLink = '/where/desalination';
const groundwaterLink = '/where/groundwater';

export const markers: LocationMarker[] = [
  {
    title: `Perth seawater desalination plant`,
    type: `desalination`,
    location: [115.7731775, -32.2029032],
    desc: `Located in Kwinana, the plant opened in 2006 and supplies an average of 15% of Perth's drinking water.`,
    year: 2006,
    link: desalLink,
  },
  {
    title: `Southern seawater desalination plant`,
    type: `desalination`,
    location: [115.7025113, -33.1272193],
    desc: `Located in Binningup, the plant opened in 2011 and supplies an average of 30% of Perth's water needs.`,
    year: 2001,
    link: desalLink,
  },
  {
    title: `Mundaring weir`,
    type: `dam`,
    location: [116.1965247, -31.982461],
    desc: `Water from the weir travels through the golden pipeline all the way to the Goldfields and Agricultural region.`,
    year: 1980,
    link: damLink,
  },
  {
    title: `Canning dam`,
    type: `dam`,
    location: [116.1279935, -32.1530101],
    desc: `Built in the built in the 1930s, it was WA's biggest public works project at the time.`,
    year: 1930,
    link: damLink,
  },
  {
    title: `Wungong dam`,
    type: `dam`,
    location: [116.0642137, -32.2013043],
    desc: `The dam has been supplying water to Perth for over 70 years.`,
    year: 1950,
    link: damLink,
  },
  {
    title: `Serpentine dam`,
    type: `dam`,
    location: [116.1004681, -32.4024504],
    desc: `This dam came about as a result of rapid industrial growth in the 1950s and Perth's urgent need for a water source to supply the Kwinana area.`,
    year: 1950,
    link: damLink,
  },
  {
    title: `North Dandalup dam`,
    type: `dam`,
    location: [116.0163774, -32.5177566],
    desc: `Perth's newest dam supplies water to Perth, Mandurah, Pinjarra, Harvey and the Goldfields.`,
    year: 1994,
    link: damLink,
  },
  {
    title: `South Dandalup dam`,
    type: `dam`,
    location: [116.0379987, -32.6484769],
    desc: `Perth's largest dam, built in 1971 in response to the city's rapidly expanding population, fuelled by the Pilbara resources boom.`,
    year: 1971,
    link: damLink,
  },
  {
    title: `Harvey dam`,
    type: `dam`,
    location: [115.9287646, -33.0772182],
    desc: `The original Harvey Weir was part of the first irrigation scheme in WA.`,
    year: 1916,
    link: damLink,
  },
  {
    title: `Serpentine pipehead dam`,
    type: `dam`,
    location: [116.058886, -32.3741568],
    desc: `The the smaller of the two damns on the Serpentine River, it's an important link back to Perth's industry boom in the late 1950s and 60s. `,
    year: 1950,
    link: damLink,
  },
  {
    title: `Victoria dam`,
    type: `dam`,
    location: [116.0678, -32.0423],
    desc: `The first dam to be constructed in WA, built in 1891 to supply drinking water for the growing populations in Perth and Fremantle`,
    year: 1891,
    link: damLink,
  },
  {
    title: `Churchman Brook`,
    type: `dam`,
    location: [116.078, -32.15004],
    desc: `Constructed in the 1920s the dam is enjoyed by the community for its striking views, modern playground and picnic areas.`,
    year: 1920,
    link: damLink,
  },
  {
    title: `Advanced water recycling plant`,
    type: `groundwater-replenishment`,
    location: [115.778334, -31.781239],
    desc: `The first full scale groundwater replenishment scheme in Australia. By 2060, this climate independent source could make up around 20% of Perth's water supply.`,
    year: 2019,
    link: '/where/groundwater-replenishment',
  },
  {
    title: `Neerabup groundwater source`,
    type: `groundwater`,
    location: [115.76152, -31.674826],
    desc: groundwaterDesc,
    year: 1960,
    link: groundwaterLink,
  },
  {
    title: `Wanneroo groundwater source`,
    type: `groundwater`,
    location: [115.710016, -31.647741],
    desc: groundwaterDesc,
    year: 1960,
    link: groundwaterLink,
  },
  {
    title: `South Whitfords groundwater source`,
    type: `groundwater`,
    location: [115.7776551, -31.7982897],
    desc: groundwaterDesc,
    year: 1960,
    link: groundwaterLink,
  },
  {
    title: `Lexia groundwater source`,
    type: `groundwater`,
    location: [115.8808831, -31.791789],
    desc: groundwaterDesc,
    year: 1960,
    link: groundwaterLink,
  },
  {
    title: `Mirrabooka groundwater source`,
    type: `groundwater`,
    location: [115.8600067, -31.8604512],
    desc: groundwaterDesc,
    year: 1960,
    link: groundwaterLink,
  },
  {
    title: `Gwelup groundwater source`,
    type: `groundwater`,
    location: [115.804211, -31.870691],
    desc: groundwaterDesc,
    year: 1960,
    link: groundwaterLink,
  },
  {
    title: `Jandakot groundwater source`,
    type: `groundwater`,
    location: [115.849817, -32.147419],
    desc: groundwaterDesc,
    year: 1960,
    link: groundwaterLink,
  },
];

export const afterMarkers: LocationMarker[] = [
  {
    title: `Alkimos wastewater treatment plant`,
    type: `wastewater-treatment`,
    location: [115.676727, -31.614837],
    desc: `The plant supports 80,000 residents in Perth's growing northen suburbs. It meets the best odour management measures in Australia and will continue to expand to support population growth beyond 2050.`,
    year: 2025,
    link: 'https://www.watercorporation.com.au/water-supply/wastewater-services/our-wastewater-treatment-plants',
  },
  {
    title: `Beenyup wastewater treatment plant`,
    type: `wastewater-treatment`,
    location: [115.777446, -31.781666],
    desc: `This plant serves around 660,000 residents in Perth's rapidly developing northern suburbs. It is also the site of Australia's first groundwater replenishment scheme.`,
    year: 2025,
    link: 'https://www.watercorporation.com.au/water-supply/wastewater-services/our-wastewater-treatment-plants',
  },
  {
    title: `Subiaco wastewater treatment plant`,
    type: `wastewater-treatment`,
    location: [115.793946, -31.95563],
    desc: `Perth's third lagest plant, servicing over 240,000 residents, providing recycled water for the McGillivray Sporting Complex, Perth's first large scale green space to use recycled water.`,
    year: 2025,
    link:
      'https://www.watercorporation.com.au/water-supply/water-recycling/water-recycling-case-studies/mcgillivray-oval-case-study',
  },
  {
    title: `Woodman Point wastewater treatment plant`,
    type: `wastewater-treatment`,
    location: [115.773023, -32.147675],
    desc: `The largest wastewater treatment plant in WA. Every day, it treats wastewater for more than 760,000 residents living in Perth's southern suburbs. The plant will continue to be upgraded to service the growing population in the area.`,
    year: 2025,
    link: 'https://www.watercorporation.com.au/water-supply/wastewater-services/our-wastewater-treatment-plants',
  },
  {
    title: `East Rockingham wastewater treatment plant`,
    type: `wastewater-treatment`,
    location: [115.7584664, -32.263035],
    desc: `The plant will cater for the needs of residents in the south west metro area for the next 50 years.`,
    year: 2025,
    link: 'https://www.watercorporation.com.au/water-supply/wastewater-services/our-wastewater-treatment-plants',
  },
];
